import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AppService } from "./app.service";
import { Router } from "@angular/router";

@Injectable()
export class AuthguardGuard implements CanActivate {
  constructor(private appService: AppService, private router: Router){}
  canActivate() {
    if (this.appService.getCurrentUser() != null) {
        return true;
    }
    else {
        this.router.navigate(['login']);
    }
    return false;
  }
}



// WEBPACK FOOTER //
// /build/client-cms/src/app/authguard.guard.ts